module.exports = __webpack_public_path__ + "media/images/xc_7-35c81fe878b86712d8d733f26c983b73.png";